import * as React from "react";
import * as moment from "moment";
import { api, user, shared, dataList } from "src/services/api";
import { classNames } from "src/services/theme";
import { Formatters, Loading, Modal, Tooltip } from "src/components/ui";

interface Props {
  costo: number;
  onRicaricaCrediti: Function;
  onDashboard: Function;
  onAdsp: Function;
  onAdwords: Function;
}

interface State {
  phase: string;
  errors: any;
  items?: any[];
  topay?: any[];
  total?: number;
  warning?: boolean;
  loading: string | null;
  scuole?: any[];
}

export default class Carrello extends React.Component<Props, State> {
  state = {
    phase: "LIST"
  } as State
  
  componentWillMount() {
    this.load(); 
  }
  
  async load() {
    const data = await api( {
      url: "ecommerce/carrello",
      loading: this
    });
    this.setState({
      ...data
    });
    
    const args = {
      id_gestore: user.id,
      ipp: 100000000000,
      stato: ['Pubblicato']
    };
    const scuole = await api({
      url: "scuola",
      params: args
    });
    this.setState({
      scuole
    })
  }
  
  async delete( item ) {
    await api( {
      url: `ads/adsp/${item.id}`,
      method: 'delete',
      loading: this
    });
    this.load();
  }
  
  async submit() {
    await api( {
      url: "ecommerce/carrello/paga",
      loading: this
    });
    this.setState({
      phase: "SUCCESS"
    })
  }
  
  async recharge() {
    const { onRicaricaCrediti } = this.props;
    const { total = 0 } = this.state;
    if (onRicaricaCrediti) {
      onRicaricaCrediti( {
        necessari: total - user.crediti
      } );
    }
  }
  
  /*
  
  async save( args ) {
    try {
      const data = await bindToAPI( this, {
            method: "POST",
            url: "ecommerce/userInfo",
            data: args,
            loading: this
      });
      this.setState({
        phase: "LIST",
        indirizzi: data.indirizzi
      });
    } catch(errors) {
      
    }
  }
  */
  
  recipientLabel( item ) {
    if (item.recipient_type === 'App\Scuola') {
      return item.recipient.nome;
    }
  }
  
  summary( item ) {
    const model = item.model.split("\\");
    if (model[2] === "Adsp") {
      if (item.tipo === "ADSP") {
        return (
          <article className="summary-adsp">
            <header>Vetrina <span className="icon-arrows_long_right" /> {item.provincia.provincia}</header>
            <div>{this.recipientLabel(item)}</div>
            <footer>
              <span>Dal </span>
              {Formatters.Date({date:item.DataInizio})}
              <span> al </span>
              {Formatters.Date({date:item.DataFine})}
            </footer>
          </article>
        );
      }
      if (item.tipo === "ADWORDS") {
        return (
          <article className="summary-adsp">
            <header>Adwords</header>
            <div>{this.recipientLabel(item)}</div>
            <footer>
              <span>Dal </span>
              {Formatters.Date({date:item.DataInizio})}
              <span> al </span>
              {Formatters.Date({date:item.DataFine})}
            </footer>
          </article>
        );
      }
    }
    return null;
  }
  
  render() {
    const { costo } = this.props;
    const {
      loading, errors, phase, items, topay, warning, total = 0,
      scuole
    } = this.state;
    // if (loading) return <Loading />;
    const canBuy = user.crediti >= total;
    return (
      <div className="ecommerce_Carrello">
        <div className="container">
        {phase === "LIST" &&
        <>
        <section className="items">
          <header>
            <h3>Il tuo carrello</h3>
          </header>
          
          {topay && topay.length > 0 &&
          <div className="list">
          <table>
            <thead>
              <tr>
                <th />
                <th>Prodotto</th>
                <th></th>
                <th>
                  <div>Prezzo crediti</div>
                  <div>Valore &euro;</div>
                </th>
              </tr>
            </thead>
            <tbody>
            {topay.map( (item,i) => {
            return (
              <tr key={i}>
                <td className="act">
                  <Tooltip title="Elimina" align="right">
                    <button className="frameless remove" onClick={() => this.delete(item) }><span className="icon-remove" /></button>
                  </Tooltip>
                </td>
                <td>
                {this.summary(item)}
                </td>
                <td className="act">
                  {!item.valid &&
                  <Tooltip title="Esaurito" align="left" color="blue">
                    <span className="icon-no_entry_filled" />
                  </Tooltip>
                  }
                </td>
                <td className="price">
                  <strong>{item.prezzo}</strong>
                  <span>{Formatters.Price({val: item.prezzo * costo})}</span>
                </td>
              </tr>
            );
            
            })}
            </tbody>
          </table>
          <table>
            <tfoot>
              <tr>
                <td />
                <td className="total">
                  <div className="overall">
                    Totale crediti
                    <strong>{total}</strong>
                    <em>Valore: {Formatters.Price({val: total * costo})}</em>
                  </div>
                  {!canBuy &&
                  <div className="buyothers">
                    Ti servono altri {total-user.crediti} crediti
                    <button className="main2 xs btn-block" onClick={() => this.recharge()}><span>Compra crediti</span></button>
                  </div>
                  }
                  {canBuy &&
                  <div className="continue">
                    <button className="main btn-block" onClick={() => this.submit()}><span>Prosegui</span></button>
                  </div>
                  }
                </td>
              </tr>
            </tfoot>
          </table>
          </div>
          }
          {!topay || topay.length === 0 &&
          <div className="none">
            Nessun prodotto è stato messo nel carrello.
          </div>
          }
        </section>
        {topay && topay.length > 0 &&
        <div className="info">
           <span className="icon-about_filled" />
           Cliccando il tasto “Prosegui” renderai il tuo acquisto valido con effetto immediato. Non sarà possibile annullarlo.
        </div>
        }
        </>
        }
        {phase === "SUCCESS" &&
        <section className="success">
          <header>
            <span className="icon-info" />
            <h2>Grazie!</h2>
            <p>Il tuo acquisto è stato completato correttamente</p>
          </header>
          {scuole && scuole.length > 0 &&
          <section>
            <h3>Vuoi acquistare servizi per le tue altre sedi?</h3>
            {scuole.map( (s,i) => (
              <article key={i}>
                <span>{i+1}</span>
                <div>
                  <span>{s.nome}</span>
                  <nav>
                    <button className="main2" onClick={() => this.props.onAdsp({id: s.id})}><span>Acquista Visor Vetrina</span></button>
                    <button className="main2" onClick={() => this.props.onAdwords({id: s.id})}><span>Acquista Visor AD Words</span></button>
                  </nav>
                </div>
              </article>
            ))}
          </section>
          }
          <footer>
            <p>Puoi verificare i tuoi acquisti nella tua dashboard</p>
            <button className="wicon pre main2" onClick={() => this.props.onDashboard()}><span><span className="icon-add" /><em>Vai alla tua dashboard</em></span></button>
          </footer>
        </section>
        }
        </div>
        
        {/* TODO !!!!!!!!! */}
        {warning &&
        <Modal
          open={true}
          backdrop={true}
          icon="user"
          className="ecommerce_Carrello_post ecommerce_AcquistiScuola_bigheader"
        >
          <header>
            <h2>Hai avanzato dei crediti!</h2>
            <hr />
            <p>
            Alcuni articoli del tuo carrello erano esauriti.<br />
            Hai un avanzo di <em>xxx crediti</em>.
            </p>
            <hr />
            <p>
            <em>Articoli esauriti:</em>
            </p>
            <ul>
              <li>Visor Vetrina - Nome Scuola - Dal xx/xx/xxx al xx/xx/xxx</li>
            </ul>
          </header>
          <footer>
            <div>
              <a className="btn lg main2"><span>Continua con gli acquisti</span></a>
            </div>
            <hr />
            <div>
              Vuoi richiedere il rimborso dei crediti in eccesso?<br />
              Scrivi a <a href="mailto:info@schoolvisor.it">info@schoolvisor.it</a>
            </div>
          </footer>
        </Modal>
        }
        
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ecommerce/Carrello.tsx